import React from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import WochitProgress from 'components/wochit-progress';
import FontIcon from 'material-ui/FontIcon';
import moment from 'moment';


const style = {
    container: {
        position: 'relative',
    },
    icon: {
        fontSize: '5em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        color: '#00A7F7',
        transform: 'translate(-50%,-50%)'
    },
    error: {
        fontSize: '5em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        color: 'red',
        transform: 'translate(-50%,-50%)'
    },
    cameraicon: {
        position: 'absolute',
        bottom: 0,
        left: 5,
        fontSize: 30
    },
    duration: {
        position: 'absolute',
        bottom: 3,
        right: 10,
        color: 'white'
    },
    errors: {
        position: 'absolute',
        bottom: 0,
        backgroundColor: 'red',
        color: 'white',
        opacity: 0.7,
        width: '100%',
        paddingTop: 10,
        height: 50
    }

};

const photoIcon = <FontIcon style={style.icon} className="material-icons">photo</FontIcon>;
const videoIcon = <FontIcon style={style.icon} className="material-icons">play_arrow</FontIcon>;
const errorIcon = <FontIcon style={style.error} className="material-icons">error_outline</FontIcon>;

const renderErrors = (errors, justFirst: false) => {

    const errorToFriendlyString = {
        upload: "Error Uploading Asset" ,
        process: "Error Processing Asset",
        load: "Error loading thumbnail",
        message(key) {
            return this[key] || key;
        }
    };
    if (_.isEmpty(errors)) {
        return null;
    }

    const keys = Object.keys(errors);
    _.remove(keys, key => {
        return key === 'load';
    });

    if (_.isEmpty(keys)) {
        return null;
    }

    if (justFirst) {
        const key = keys[0];
        return  <div style={style.errors}><span key={key}>{errorToFriendlyString.message(key)}</span></div>
    }


    return  <div style={style.errors}>{keys.map(key => <span key={key}>{errorToFriendlyString.message(key)}</span>)}</div>;
};

// Using "Stateless Functional Components"
const GalleryItem =  function(props) {
    let className = 'wt-asset';
    let errors = (!_.isEmpty(props.errors)) ? props.errors : null;
    const camera = props.isVideo ? <FontIcon style={style.cameraicon} className="material-icons" color="white">videocam</FontIcon> : null;
    const duration = props.duration? moment.utc(props.duration * 1000).format('m:ss'): null;
    const durationEl = duration ? <span style={style.duration}>{duration}</span> : null;
    if (errors) {
        className += ' wt-error ';
        className += Object.keys(errors).map(key => 'wt-error-' + key).join(' ');
    }

    let asset;
    if (props.isVideo) {
        let thumbnail = props.poster || props.thumbnail;
        if (_.isEmpty(thumbnail)) {
            //url = url.startsWith('blob:') ? url : '//' + url;
            asset = videoIcon;
        } else {
            thumbnail = /^(blob|data):/.test(thumbnail) ? thumbnail : '//' + thumbnail;
            asset = <img role="presentation" src={thumbnail} onError={props.onError}/>;
        }
    } else if (props.isGif) {
        if (_.isEmpty(props.animatedGifUrl) && _.isEmpty(props.thumbnail)) {
            asset = <h3>Gif Error</h3>
        } else {
            const url = _.isEmpty(props.animatedGifUrl) ? props.thumbnail : props.animatedGifUrl;
            const src = /^(blob|data):/.test(url) ? url : '//' + url;
            asset = <img role="presentation" src={src} onError={props.onError}/>;

            if (errors && errors.load) {
                asset = <FontIcon className="material-icons" style={style.icon}>broken_gif</FontIcon>
            }
        }
    } else {
        if (_.isEmpty(props.thumbnail)) {
            if (props.uploadStatus === 'PROCESSING') {
                asset = photoIcon;
            } else if (props.uploadStatus === 'FAILED') {
                asset = errorIcon;
            } else {
                asset = photoIcon;
            }
        } else {
            const thumbnail = /^(blob|data):/.test(props.thumbnail) ? props.thumbnail : '//' + props.thumbnail;
            asset = <img role="presentation" src={thumbnail} onError={props.onError}/>;
            if (errors && errors.load) {
                asset = <FontIcon className="material-icons" style={style.icon}>broken_image</FontIcon>
            }
        }
    }

    const targetUrl = '/assets/' + (props.assetUUID || props.tempUUID);
    return <Link to={targetUrl} className={className}>
        <WochitProgress uploadStatus={props.uploadStatus} percentComplete={props.percentComplete} fileSize={props.fileSize} width="95%"/>
        {asset}
        {camera}
        {durationEl}
        {renderErrors(props.errors, true)}
    </Link>;
};

export default GalleryItem;
